import { useOrganizationAttachmentPreferences } from '#pplx/frontend/apps/ask/organization/hooks/useOrganizationAttachmentPreferences.js';
import { FILE_RETENTION_MESSAGE } from '#pplx/frontend/file-uploads/fileRetentionMessage.js';
import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
export const useAskInputAttachments = ({ enabled = true, handleFileInput, fileUploadErrorMessage, fileUploadWarningMessage, setAttachmentErrorMessage, uploadPolicy, gateUploadFile, }) => {
    const { $t } = useIntl();
    const reason = 'ask-input-attachments-hook';
    const onCloseErrorToast = useCallback(() => {
        setAttachmentErrorMessage?.('');
    }, [setAttachmentErrorMessage]);
    const { disabledByOrganization } = useOrganizationAttachmentPreferences({ reason });
    return useMemo(() => {
        if (enabled && handleFileInput && uploadPolicy && gateUploadFile)
            return {
                showAttachments: true,
                acceptedFileTypes: uploadPolicy.constraints.acceptedFileTypes,
                disabledByOrganization,
                onFilesSelected: handleFileInput,
                gateUploadFile,
                canUploadFile: uploadPolicy.gate.canUploadFile,
                fileMenuMessage: uploadPolicy.menuMessage,
                fileRetentionMessage: uploadPolicy.retentionDays === undefined
                    ? undefined
                    : $t(FILE_RETENTION_MESSAGE, {
                        days: uploadPolicy.retentionDays,
                    }),
                fileUploadErrorMessage: fileUploadErrorMessage ?? null,
                fileUploadWarningMessage: fileUploadWarningMessage ?? null,
                onCloseErrorToast,
            };
        return {
            showAttachments: false,
        };
    }, [
        enabled,
        handleFileInput,
        uploadPolicy,
        gateUploadFile,
        $t,
        fileUploadErrorMessage,
        fileUploadWarningMessage,
        onCloseErrorToast,
        disabledByOrganization,
    ]);
};
//# sourceMappingURL=useAskInputAttachments.js.map